import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const AppointmentEfficiencyChart = ({ data }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Appointment Scheduling Efficiency</h2>
          <p className="text-sm text-muted-foreground mt-1">Weekly trends in appointment management</p>
        </div>
        <Icon name="Calendar" size={24} color="var(--color-primary)" />
      </div>

      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Appointment Efficiency Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="day" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
            />
            <Line 
              type="monotone" 
              dataKey="scheduled" 
              stroke="var(--color-primary)" 
              strokeWidth={2}
              name="Scheduled"
              dot={{ r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="completed" 
              stroke="var(--color-success)" 
              strokeWidth={2}
              name="Completed"
              dot={{ r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="noShow" 
              stroke="var(--color-error)" 
              strokeWidth={2}
              name="No-Show"
              dot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
        <div className="p-4 rounded-lg bg-primary/10">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Calendar" size={16} color="var(--color-primary)" />
            <span className="text-xs font-medium text-muted-foreground">Avg. Scheduled</span>
          </div>
          <span className="text-xl md:text-2xl font-bold text-foreground">342</span>
          <span className="text-xs text-muted-foreground ml-2">per day</span>
        </div>
        <div className="p-4 rounded-lg bg-success/10">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="CheckCircle" size={16} color="var(--color-success)" />
            <span className="text-xs font-medium text-muted-foreground">Completion Rate</span>
          </div>
          <span className="text-xl md:text-2xl font-bold text-foreground">91.5%</span>
        </div>
        <div className="p-4 rounded-lg bg-error/10">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="XCircle" size={16} color="var(--color-error)" />
            <span className="text-xs font-medium text-muted-foreground">No-Show Rate</span>
          </div>
          <span className="text-xl md:text-2xl font-bold text-foreground">8.5%</span>
        </div>
      </div>
    </div>
  );
};

export default AppointmentEfficiencyChart;